import { sendData, getData } from './../../misc/server.js';
export default {
    state: {
        loading: false,
        user: null,
        user_activation:false,
    },
    mutations:
    {
        SET_LOADING(state, payload) {
            state.loading = payload;
        },
        SET_LOGIN_STATE(state, payload) {
            state.user = payload;
        },
        setActivation(state,payload)
        {
            state.user_activation=payload;
        }
    },
    actions: {

        async login({ commit }, payload) {

            var url = "login";
            commit('SET_ERROR', null, { root: true })
            commit('SET_LOADING', true);

            var response = await sendData(url, payload);
            if (response.success) {
                localStorage.setItem("online_learning_site_user", JSON.stringify(response.data));
                commit('SET_LOGIN_STATE', response);
            }
            else {

                commit('SET_ERROR', response.message, { root: true })
            }
            commit('SET_LOADING', false);


           
        },
        checkLogin({ commit }) {
            var user = JSON.parse(localStorage.getItem("online_learning_site_user"));
            commit('SET_LOGIN_STATE', user);
        },
        logout({ commit }) {

            localStorage.removeItem("online_learning_site_user")
            commit('SET_LOGIN_STATE', null);
        },
        checkActivation({commit})
        {
            var user = JSON.parse(localStorage.getItem("online_learning_site_user"));
            if (user)
            {
                if (user.activation_status && user.activation_status ==1)
                {
                    commit("setActivation",true);
                }
                else 
                {
                    commit("setActivation",false);
                }
            }
            else 
            {
                commit("setActivation",false);
            }
        },
        async passwordChange({commit},payload)
        {
            var url = "password/change";
            commit('SET_ERROR', null, { root: true })
            commit('SET_LOADING', true);

            var response = await sendData(url, payload);
            if (response.success) {
                var user = JSON.parse(localStorage.getItem("online_learning_site_user"));
                user.activation_status=1;
                localStorage.setItem("online_learning_site_user",JSON.stringify(user));
                commit('SET_SUCCESS', response.message, { root: true })
                commit("setActivation",true);
            }
            else {
                commit('SET_ERROR', response.message, { root: true })
            }
            commit('SET_LOADING', false);
        }

    },
    getters: {

        login_loading(state) {
            return state.loading;
        },
        auth(state) {
            return state.user;
        },
        user_activation(state)
        {
            return state.user_activation;
        }


    }
}